import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { SvgImage } from './SvgImage';
import { NewArrowTopIcon } from '../../style/images';
import classNames from 'classnames';

const AccordionHeader = ( { children, expanded, index, onSelect,fromModelConfigurator } ) => {
  const select = () => onSelect( index );
  const onHeaderClick = e => !svgTags.includes( e.target.tagName ) && select();
  const svgTags = ['svg', 'path', 'polygon','SPAN'];
  const className = children.props.children?.includes('Wild Articles') ? classNames( 'accordion-header-wild') : classNames( 'accordion-header', { 'expanded': expanded } );
  return fromModelConfigurator ? <div className={ className } onClick={ onHeaderClick }>
    {!children.props.children?.includes('Wild Articles') ? <SvgImage source={ NewArrowTopIcon } onClick={ select }/> : null}
    { children }
  </div> : <div className={ className } onClick={ onHeaderClick }>
    <SvgImage source={ NewArrowTopIcon } onClick={ select }/>
    { children }
  </div>;
};
export class Accordion extends Component {
  constructor( props ) {
    super( props );
    this.state = {
      accordionState: { }
    };

    this.noParent = [];
  }

  handleHeaderClicked = accordionIndex => {
    this.setState( {
      accordionState: {
        ...this.state.accordionState,
        [accordionIndex]: !this.getAccordionState( accordionIndex )
      }
    } );
  }

  getAccordionState( accordionIndex ) {
    let { defaultExpanded } = this.props;
    return this.state.accordionState[accordionIndex] === undefined ? defaultExpanded : this.state.accordionState[accordionIndex];
  }

  getItems() {
    let { children } = this.props;

    return ( children || [] ).reduce( ( current, item ) => {
      if ( !item ) {
        // null shouldn't be rendered
        return current;
      }
      if ( Array.isArray( item ) ) {
        if ( current.length ) {
          // only start when at least one header was added
          current[current.length - 1].children.push( item );
        } else {
          this.noParent.push( item );
        }
        return current;
      }
      if ( !item.type ) {
        // will be a hidden item
        current.push( { header: null, children: [] } );
        return current;
      }
      if ( !item.type.match && item.type.apply ) {
        let rendered = item; //( { ...item.props, key: item.key } );
        if ( !rendered ) {
          return current;
        }
        let children = Array.isArray( rendered ) || !rendered.props || !rendered.props.children ? rendered : rendered.props.children;
        if ( !children.forEach ) {
          children = [children];
        }
        children.forEach( ( child, ck ) => {
          if ( !child ) {
            return;
          }
          if ( child.type && child.type.match && child.type.match( /h\d/gi ) ) {
            current.push( { header: child, children: [] } );
          } else if ( current.length ) {
            current[current.length - 1].children.push( {...child, key: ck } );
          } else {
            this.noParent.push( child );
          }
        } );
        return current;
      }
      if ( item.type.match( /h\d/gi ) ) {
        current.push( { header: item, children: [] } );
        return current;
      }
      if ( current.length ) {
        // only start when at least one header was added
        current[current.length - 1].children.push( item );
      } else {
        this.noParent.push( item );
      }
      return current;
    }, [] );
  }
  
  resetState() {
    this.setState( { accordionState: {} } );
  }

  renderContent( expanded, index, children,fromModelConfigurator ) {
    return !expanded ? null : <div key={ `${index}_content` } className={fromModelConfigurator ? "accordion-content fromModelConfigurator" :"accordion-content"}>
      { children }
    </div>;
  }

  render() {
    const items = this.getItems();
    const className = classNames( 'accordion', this.props.className );
    
    const accordions = items.map( ( item, index ) => {
      const expanded = this.getAccordionState( index );
      
      return !item.header ? null : [
        <AccordionHeader key={ `${index}_header` } expanded={ expanded } children={ item.header } index={ index } onSelect={ this.handleHeaderClicked } fromModelConfigurator = {this.props.fromModelConfigurator} />,
        this.renderContent( expanded, index, item.children,this.props.fromModelConfigurator )
      ];
    } );

    return <div className={ className } style={this.props.style}>
      { this.noParent && this.noParent.length > 0 && this.noParent }
      { accordions } 
    </div>;
  }
}

Accordion.propTypes = {
  children: PropTypes.arrayOf( PropTypes.oneOfType( [PropTypes.node, PropTypes.func, PropTypes.elementType] ) ),
  className: PropTypes.string,
  defaultExpanded: PropTypes.bool
};